import '../App.css';


function ProgressCheckout({estilo}){


    return (
        <div class="progress-checkout-container">
            <div class="progress-step-container">
                <div className={estilo === 1?'step-check':'step-check-active'}></div>
                <span class="step-title">Orden</span>
            </div>
            <div class="progress-step-container">
                <div style={estilo === 2?{border:'2px solid #fb8cff'}:{}} className={estilo === 2?'step-check':
                estilo === 3?'step-check-active':'step-check'}></div>
                <span class="step-title">Dirección</span>
            </div>
            <div class="progress-step-container">
                <div style={estilo === 3?{border:'2px solid #fb8cff'}:{}} class="step-check"></div>
                <span class="step-title">Completar</span>
            </div>
        </div>
    )
}

export default ProgressCheckout
